import { Heading, Grid, Text } from '@simplywallst/ui-core';

import { toSignificant } from '@/utilities/formatting';
import { formatterPercentage, formatterCurrency } from '@/utilities/format';

import { Tile } from '@/components/MonitoringPanel';

import type { Holding } from '@/hooks/portfolio/usePortfolio';

interface Props {
  holding: Holding;
}

export const HoldingPanel = ({ holding }: Props) => {
  const { analysis, company, currencyISO, units, averagePurchasePrice } =
    holding;
  const { trading_item_currency_iso: companyCurrencyISO } =
    company.data.currencyInfo;
  return (
    <Grid gap="8px">
      <Tile templateRows="repeat(2, max-content)" gap="16px">
        <Heading
          as="h3"
          typography="tinyStrong"
          color="whiteRGBA"
          opacity={0.5}
        >
          Summary
        </Heading>
        <Grid templateColumns="repeat(2, 1fr)" rowGap="8px">
          <Grid data-cy-id="allocation">
            <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
              Weight
            </Text>
            <Text typography="small">
              {formatterPercentage(analysis.allocation)}
            </Text>
          </Grid>
          <Grid data-cy-id="capital-invested">
            <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
              Capital Invested
            </Text>
            <Text typography="small">
              {formatterCurrency(analysis.capitalInvested, currencyISO)}
            </Text>
          </Grid>
          <Grid data-cy-id="shares">
            <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
              No. of Shares
            </Text>
            <Text typography="small">{toSignificant(units, 2)}</Text>
          </Grid>
          <Grid data-cy-id="avg-cost-price">
            <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
              Avg Cost Price
            </Text>
            <Text typography="small">
              {formatterCurrency(averagePurchasePrice, companyCurrencyISO)}
            </Text>
          </Grid>
        </Grid>
      </Tile>
      <Tile templateRows="max-content 120px" gap="16px">
        <Heading
          as="h3"
          typography="tinyStrong"
          color="whiteRGBA"
          opacity={0.5}
        >
          Transactions
        </Heading>
        <Grid placeItems="center">
          <Text typography="small" color="whiteRGBA" opacity={0.3}>
            Coming soon
          </Text>
        </Grid>
      </Tile>
    </Grid>
  );
};
